<template>
  <user-manager
    v-bind:canEdit="false"
    v-bind:canDelete="true"
    v-bind:context="'kiosk-all'"
    v-bind:functionalRoles="functionalRoles"
    v-bind:toolbarColor="appColor_Abby"
    v-bind:toolbarColorDark="appColor_AbbyDark"
  />
</template>

<script>
import UserManager from '@/components/UserManager'
import { AppColor } from '@/config.js'

export default {
  name: 'AbbyKioskParticpants',
  components: {
    UserManager
  },
  data() {
    return {
      appColor_Abby: AppColor.KioskTypeAbbyLight,
      appColor_AbbyDark: AppColor.KioskTypeAbby,
    }
  },
  computed: {
    functionalRoles () {
      return [
        this.getExpression('FunctionalRole', 'FamilyFacilitator'),
        this.getExpression('FunctionalRole', 'KioskManager'),
        this.getExpression('FunctionalRole', 'DomainManager')
      ]
    }
  }
}
</script>